import React from "react";

const CircularProgress = () => {
  return (
    <svg className="tuby-progress" viewBox="25 25 50 50">
      <circle cx="50" cy="50" r="20"></circle>
    </svg>
  );
};

export default CircularProgress;
